import Vue from "vue";


export default function initFactory(module) {
  return function (selector, options, props) {
    return new Vue({
      el: selector,
      render(h) {
        return h(module, {
          props: props
        });
      }
    });
  }
}
